export function hairScholarQuiz(jsonPath) {
  return {
    currentScreen: 'quiz',
    questions: [],
    currentQuestion: 0,
    answers: [], // 각 문제의 답변 저장 (null, true, false)
    correctCount: 0,

    async init() {
      try {
        const response = await fetch(jsonPath);
        const data = await response.json();
        this.questions = data.quizzes;

        // answers 배열 초기화 (50개 모두 null로)
        this.answers = new Array(50).fill(null);

        // 세션 스토리지에서 진행 상태 복원
        this.loadProgress();
      } catch (error) {
        console.error('퀴즈 데이터 로드 실패:', error);
      }
    },

    loadProgress() {
      const saved = sessionStorage.getItem('hairQuizProgress');
      if (saved) {
        const progress = JSON.parse(saved);
        this.currentQuestion = progress.currentQuestion || 0;
        this.answers = progress.answers || new Array(50).fill(null);
        this.correctCount = progress.correctCount || 0;
      }
    },

    saveProgress() {
      const progress = {
        currentQuestion: this.currentQuestion,
        answers: this.answers,
        correctCount: this.correctCount,
      };
      sessionStorage.setItem('hairQuizProgress', JSON.stringify(progress));
    },

    startQuiz() {
      this.currentScreen = 'quiz';
    },

    selectAnswer(answer) {
      // 이미 답변한 문제는 선택 불가
      if (this.answers[this.currentQuestion] !== null) return;

      // 답변 저장
      this.answers[this.currentQuestion] = answer;

      // 정답 체크
      const isCorrect = answer === this.questions[this.currentQuestion].answer;
      if (isCorrect) {
        this.correctCount++;
      }

      this.saveProgress();
    },

    nextQuestion() {
      if (this.currentQuestion < 49) {
        this.currentQuestion++;
        this.saveProgress();
      } else {
        // 마지막 문제 완료
        this.currentScreen = 'result';
        this.saveProgress();
      }
    },

    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.saveProgress();
      }
    },

    getButtonClass(buttonValue) {
      const currentAnswer = this.answers[this.currentQuestion];
      const correctAnswer = this.questions[this.currentQuestion]?.answer;

      let classes = [];

      // 1. 선택된 버튼인지 확인
      if (currentAnswer === buttonValue) {
        classes.push('selected');
      }

      // 2. 답변을 했다면 정답/오답 표시
      if (currentAnswer !== null) {
        // 이 버튼이 선택된 버튼이라면
        if (currentAnswer === buttonValue) {
          // 선택한 답이 정답인지 확인
          if (currentAnswer === correctAnswer) {
            classes.push('correct');
          } else {
            classes.push('wrong');
          }
        }
      }

      return classes.join(' ');
    },

    getRank() {
      const score = this.correctCount;
      const ranks = [
        {
          min: 50,
          title: '🏆 헤어케어 박사',
          message: '완벽합니다! 헤어케어 마스터입니다!',
        },
        {
          min: 45,
          title: '🎓 헤어케어 장학사',
          message: '훌륭합니다! 헤어케어 지식이 풍부하시네요!',
        },
        {
          min: 40,
          title: '⭐ 헤어케어 전문가',
          message: '대단합니다! 헤어케어에 대해 잘 알고 계시네요!',
        },
        {
          min: 35,
          title: '👨‍🎓 헤어케어 우등생',
          message: '좋아요! 기본기가 탄탄합니다!',
        },
        {
          min: 25,
          title: '📚 헤어케어 학생',
          message: '괜찮아요! 조금만 더 공부하면 됩니다!',
        },
        {
          min: 0,
          title: '🌱 헤어케어 새싹',
          message: '다시 도전해서 실력을 높여보세요!',
        },
      ];

      return ranks.find((rank) => score >= rank.min);
    },

    restart() {
      this.currentScreen = 'intro';
      this.currentQuestion = 0;
      this.answers = new Array(50).fill(null);
      this.correctCount = 0;

      sessionStorage.removeItem('hairQuizProgress');
    },
  };
}
